<!--
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2021-12-10 15:34:21
 * @LastEditors: ankeji
 * @LastEditTime: 2021-12-10 15:46:23
-->
<!-- 所有产品的头部header和tab切换 -->
<template>
  <div>
    <!-- 头部信息-->
    <headView :product="product"></headView>
    <!-- 选项卡 -->
    <tabView :product="product"></tabView>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import tabView from './tabView.vue';
import headView from './headView.vue';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { headView, tabView },
  data() {
    //这里存放数据
    return {
      product: {}
    };
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const { u, p } = this.$route.query;
    let userParams = {
      //从地址中获取
      userId: u,
      productCode: p
    };
    this.$api.querproduct(userParams).then(res => {
      let content = res.data.content || [];
      this.product = content;
    });
  },
};
</script>
<style scoped></style>
